import { jsx as _jsx } from "react/jsx-runtime";
import { QuickAddTrackingEventsContextBaseProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/__internal__/QuickAddTrackingEventsProviders/QuickAddTrackingEventsContextBaseProvider";
import { useGetCartItemToken } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useGetCartItemToken";
import { useOptimisticBrandCartUpdate } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useOptimisticBrandCartUpdate";
import { ICartItemV2 } from "@faire/web-api--source/faire/carts/ICartItemV2";
import React, { useCallback } from "react";
export var BrandPageQuickAddTrackingEventsContextProvider = function(param) {
    var data = param.data, children = param.children;
    var _data_quickAdd_quick_add_option, _data_quickAdd;
    var _data_brandToken;
    var addBrandCartItems = useOptimisticBrandCartUpdate((_data_brandToken = data.brandToken) !== null && _data_brandToken !== void 0 ? _data_brandToken : "").addBrandCartItems;
    var _data_brandToken1;
    var findCartItemToken = useGetCartItemToken((_data_brandToken1 = data.brandToken) !== null && _data_brandToken1 !== void 0 ? _data_brandToken1 : "");
    var onQuickAddClick = useCallback(function(param) {
        var newQuantity = param.newQuantity;
        var _data_quickAdd_quick_add_option, _data_quickAdd;
        addBrandCartItems([
            ICartItemV2.build({
                name: data.productName,
                image: data.productImage,
                product_token: data.productToken,
                product_option_token: (_data_quickAdd = data.quickAdd) === null || _data_quickAdd === void 0 ? void 0 : (_data_quickAdd_quick_add_option = _data_quickAdd.quick_add_option) === null || _data_quickAdd_quick_add_option === void 0 ? void 0 : _data_quickAdd_quick_add_option.option_token,
                quantity: newQuantity
            })
        ]);
    }, [
        data.productName,
        data.productImage,
        data.productToken,
        addBrandCartItems,
        (_data_quickAdd = data.quickAdd) === null || _data_quickAdd === void 0 ? void 0 : (_data_quickAdd_quick_add_option = _data_quickAdd.quick_add_option) === null || _data_quickAdd_quick_add_option === void 0 ? void 0 : _data_quickAdd_quick_add_option.option_token
    ]);
    return /*#__PURE__*/ _jsx(QuickAddTrackingEventsContextBaseProvider, {
        data: data,
        onQuickAddButtonClick: onQuickAddClick,
        getCartItemTokenByProductToken: findCartItemToken,
        children: children
    });
};
